import React, { Component } from 'react';
import Drawer from 'rc-drawer';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import AppModuleHeader from 'components/AppModuleHeader/index';
import SurveyGroupQuestionList from 'components/Agile/SurveyGroupQuestion/SurveyGroupQuestionList';
import AddSurveyGroupQuestion from 'components/Agile/SurveyGroupQuestion/AddSurveyGroupQuestion';
import IntlMessages from 'util/IntlMessages';
import CircularProgress from 'components/CircularProgress';
import CustomScrollbars from 'util/CustomScrollbars';

import {
    fetchSurveyQuestions,
    hideSurveyQuestionLoader,
    showSurveyQuestionLoader,
} from 'actions/SurveyQuestion';

import {
    onAddSurveyGroupQuestion,
    onSurveyGroupQuestionClose,
    onSaveSurveyGroupQuestion,
    onToggleSurveyGroupQuestionDrawer,
} from 'actions/SurveyGroupQuestion';

import {
    showSurveyGroupLoader,
} from 'actions/SurveyGroup';

class SurveyGroupQuestion extends Component {
    surveyGroupQuestionSideBar = () => {
        return <div className="module-side">
            <div className="module-side-header">
                <div className="module-logo">
                    <i className="zmdi zmdi-city-alt mr-4" />
                    <span><IntlMessages id="sidebar.surveyGroupQuestion" /></span>
                </div>
            </div>

            <div className="module-side-content">
                <CustomScrollbars className="module-side-scroll scrollbar"
                    style={{ height: this.props.width >= 1200 ? 'calc(100vh - 200px)' : 'calc(100vh - 80px)' }}>
                    <div className="module-add-task">
                        <Button className="btn-block jr-btn" color="primary"
                            onClick={this.onAddSurveyGroupQuestion}>
                            <i className="zmdi zmdi-accounts-add zmdi-hc-fw" />
                            <span>Add New Question</span>
                        </Button>
                    </div>
                </CustomScrollbars>
            </div>
        </div>;

    };

    onAddSurveyGroupQuestion = () => {
        this.props.onAddSurveyGroupQuestion();
    };
    onSurveyGroupQuestionClose = () => {
        this.props.onSurveyGroupQuestionClose();
    };
    onSaveSurveyGroupQuestion = (data) => {
        this.props.onSaveSurveyGroupQuestion(data);
    };
    onDeleteSurveyGroupQuestion = (data) => {
        this.props.onDeleteSurveyGroupQuestion(data);
    };
    handleSurveyGroupQuestionRequestClose = () => {
        this.props.handleSurveyGroupQuestionRequestClose();
    };
    onToggleSurveyGroupQuestionDrawer = () => {
        this.props.onToggleSurveyGroupQuestionDrawer();
    };
    showSurveyQuestionLoader = () => {
        this.props.showSurveyQuestionLoader();
    };
    showSurveyGroupLoader = () => {
        this.props.showSurveyGroupLoader();
    }

    constructor() {
        super();
    }

    componentDidMount() {
        this.props.showSurveyQuestionLoader();
        this.props.fetchSurveyQuestions();
    }

    render() {
        const {
            surveyGroupQuestion,
            addSurveyGroupQuestionState,
            alertMessage,
            showMessage,
            drawerState,
            noContentFoundMessage,
            loader,
            selectedSurveyGroup,
            surveyQuestionList,
        } = this.props;
        return (
            <div className="app-wrapper">
                <div className="app-module animated slideInUpTiny animation-duration-3">

                    <div className="d-block d-xl-none">
                        <Drawer
                            touch={true}
                            transitions={true}
                            enableDragHandle={true}
                            open={drawerState}
                            onOpenChange={this.onToggleSurveyGroupQuestionDrawer.bind(this)}
                            sidebar={this.surveyGroupQuestionSideBar(surveyGroupQuestion)} />
                    </div>
                    <div className="app-module-sidenav d-none d-xl-flex">
                        {this.surveyGroupQuestionSideBar(surveyGroupQuestion)}
                    </div>

                    <div className="module-box">
                        <div className="module-box-header">
                            <span className="icon-btn drawer-btn d-flex d-xl-none"
                                onClick={this.onToggleSurveyGroupQuestionDrawer.bind(this)}>
                                <i className="zmdi zmdi-menu" />
                            </span>
                            <AppModuleHeader placeholder="Search Unavailable" notification={false} apps={false}
                                user={this.props.surveyGroup}
                                onChange={() => { }}
                                value={this.props.searchSurveyGroup} />
                        </div>
                        <div className="module-box-content">
                            <CustomScrollbars className="module-list-scroll scrollbar"
                                style={{ height: this.props.width >= 1200 ? 'calc(100vh - 265px)' : 'calc(100vh - 245px)' }}>
                                {loader ?
                                    <div
                                        className="loader-view-block h-100">
                                        <div className="loader-view">
                                            <CircularProgress />
                                        </div>
                                    </div>
                                    :
                                    selectedSurveyGroup ?.questions ?.length === 0 ?
                                        <div className="h-100 d-flex align-items-center justify-content-center">
                                            {noContentFoundMessage}
                                        </div>
                                        : <SurveyGroupQuestionList
                                            surveyQuestionList={surveyQuestionList}
                                            selectedSurveyGroup={selectedSurveyGroup}
                                            onDeleteSurveyGroupQuestion={this.onDeleteSurveyGroupQuestion.bind(this)}
                                            showSurveyQuestionLoader={this.showSurveyQuestionLoader.bind(this)} />
                                }
                            </CustomScrollbars>

                        </div>
                    </div>
                </div>
                <AddSurveyGroupQuestion
                    surveyQuestions={surveyQuestionList}
                    surveyGroup={selectedSurveyGroup}
                    open={addSurveyGroupQuestionState}
                    surveyGroupQuestion={{ id: '' }}
                    onSaveSurveyGroupQuestion={this.onSaveSurveyGroupQuestion.bind(this)}
                    onSurveyGroupQuestionClose={this.onSurveyGroupQuestionClose.bind(this)}
                    showSurveyGroupLoader={this.showSurveyGroupLoader}
                />

                {showMessage && NotificationManager.success(alertMessage, this.handleSurveyGroupQuestionRequestClose())}
                <NotificationContainer />

            </div>
        );
    }
}

const mapStateToProps = ({ surveyQuestions, surveyGroups, settings, surveyGroupQuestions }) => {
    const { width } = settings;
    const {
        loader,
        alertMessage,
        showMessage,
        surveyQuestionList,
    } = surveyQuestions;
    const {
        selectedSurveyGroup,
        surveyGroup,
    } = surveyGroups;
    const {
        addSurveyGroupQuestionState,
        drawerState,
    } = surveyGroupQuestions;
    return {
        width,
        loader,
        alertMessage,
        showMessage,
        surveyQuestionList,
        selectedSurveyGroup,
        surveyGroup,
        addSurveyGroupQuestionState,
        drawerState,
    };
};
export default connect(mapStateToProps, {
    fetchSurveyQuestions,
    showSurveyQuestionLoader,
    hideSurveyQuestionLoader,
    onAddSurveyGroupQuestion,
    showSurveyGroupLoader,
    onSurveyGroupQuestionClose,
    onSaveSurveyGroupQuestion,
    onToggleSurveyGroupQuestionDrawer,
})(SurveyGroupQuestion);


// WEBPACK FOOTER //
// ./components/Agile/SurveyGroupQuestion/index.js